import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "ui/molecules/Switch";
import Container from "@mui/material/Container";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { User } from "types";

const UsersTable = ({ onChange, users }: any) => {
  const handleChange = (user: User) => {
    onChange(user);
  };

  const dataGridMapper = (users: User[]): User[] =>
    users?.map((user: User) => ({
      id: user?.userID,
      ...user,
    })) ?? [];

  const dataGridColumns: GridColDef[] = [
    { field: "name", headerName: "Nombre", minWidth: 300 },
    { field: "eMail", headerName: "Email", width: 300 },
    {
      field: "status",
      headerName: "Activar",
      type: "actions",
      width: 220,
      renderCell: (params) => {
        const { row } = params;
        return <Switch onChange={() => handleChange(row)} checked={row.isActive} />;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      type: "actions",
      width: 220,
      renderCell: (params) => (
        <Link to={`/admin/user-edit/${params.id}`}>
          <IconButton aria-label='edit' size='small'>
            <EditIcon fontSize='inherit' />
          </IconButton>
        </Link>
      ),
    },
  ];

  return users?.length > 0 ? (
    <ContainerStyled maxWidth='xl'>
      <div style={{ height: 615, width: "100%" }}>
        <DataGrid columns={dataGridColumns} rows={dataGridMapper(users)} disableSelectionOnClick />
      </div>
    </ContainerStyled>
  ) : null;
};

export default UsersTable;

const ContainerStyled = styled(Container)`
  background-color: ${({ theme }) => theme.palette.background.default};
  height: 675px;
  padding: 1.7rem;
  margin: "auto";
`;
